import { useEffect, useState } from 'react';

export const MediaBreakpoints = {
  MOBILE: 768,
  TABLET: 1024,
};

export const useIsViewPortLessOrEqualTo = (screenSize: number): boolean => {
  const [isLessOrEqualTo, setIsLessOrEqualTo] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.innerWidth <= screenSize;
  });

  useEffect(() => {
    const handleResize = (): void => {
      setIsLessOrEqualTo(window.innerWidth <= screenSize);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [screenSize]);

  return isLessOrEqualTo;
};
